module.exports = __webpack_public_path__ + "static/media/logo-footer@200.188baed7.png";